// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import axios from 'axios'; // 引入 axios
Vue.prototype.$axios = axios; // 将 axios 挂载到 Vue 的原型上
axios.defaults.baseURL = '/' // 开发本地代理

import { get, post } from "@/api/apiService.js";
Vue.prototype.get = get;
Vue.prototype.post = post;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js